import React from 'react';
import { Col } from '../../../lib/utils';
import { Body2Bold } from '../../../lib/font';
import { colors } from '../../../lib/colors';

interface StickyBottomButtonProps {
    text: string;
    onClick: () => void;
    disabled?: boolean;
}

const StickyBottomButton: React.FC<StickyBottomButtonProps> = ({ text, onClick, disabled = false }) => {
    return (
        <Col
            style={{
                position: 'sticky',
                bottom: 0,
                width: '100%',
                padding: '12px 20px',
                paddingBottom: 'max(12px, env(safe-area-inset-bottom))',
                backgroundColor: '#FFFFFF',
                borderTop: '1px solid #F0F0F0',
            }}
        >
            <button
                onClick={onClick}
                disabled={disabled}
                style={{
                    width: '100%',
                    height: 52,
                    borderRadius: 12,
                    border: 'none',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    backgroundColor: disabled ? colors.GREY_200 : colors.primary,
                    transition: 'background-color 0.2s',
                }}
            >
                <Body2Bold style={{ color: disabled ? colors.LAVEL_1 : '#FFFFFF' }}>
                    {text}
                </Body2Bold>
            </button>
        </Col>
    );
};

export default StickyBottomButton;
